import { api } from '../lib/api'
import type { CommitEntry } from './draft-sync'

/** An unfinished log entry kept by the wizard (server: farm_logs_drafts). */
export type LogDraft = {
  id: string
  farmId: string
  kind: string
  step: number
  payload: Record<string, unknown>
  /** Set once the draft became an entry; such a draft can't be edited or committed again. */
  committedAt: string | null
  createdAt: string
  updatedAt: string
}

const base = (orgId: string, farmId: string) => `/orgs/${orgId}/farms/${farmId}/log-drafts`

export const draftsApi = {
  list: (orgId: string, farmId: string) => api.get<LogDraft[]>(base(orgId, farmId)),
  get: (orgId: string, farmId: string, id: string) => api.get<LogDraft>(`${base(orgId, farmId)}/${id}`),
  create: (orgId: string, farmId: string, body: { kind: string; step: number; payload: Record<string, unknown> }) =>
    api.post<LogDraft>(base(orgId, farmId), body),
  update: (orgId: string, farmId: string, id: string, body: { step: number; payload: Record<string, unknown> }) =>
    api.patch<LogDraft>(`${base(orgId, farmId)}/${id}`, body),
  /** Creates the entries and retires the draft. Safe to retry: a repeat returns the entries already made. */
  commit: (orgId: string, farmId: string, id: string, body: { entries: CommitEntry[] }) =>
    api.post<{ draft: LogDraft; entries: { kind: string; entry: { id: string } }[]; replayed: boolean }>(`${base(orgId, farmId)}/${id}/commit`, body),
  remove: (orgId: string, farmId: string, id: string) => api.delete<null>(`${base(orgId, farmId)}/${id}`),
}
